module.exports = __webpack_public_path__ + "img/banner2.fdd0b781.png";